import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Modal, RadioButton, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import routes from '../../../../routes';
import storage from '../../../../app/api/storage';
import { RadioWrapper } from './style';
import { GLOBAL_COURSE_LIST_EXPORT } from '../../../../app/redux/actions/courselist';

export const ModalSelectExportId = 'ModalSelectExport';

const ModalSelectExport = ({ mediaIsPhone, modalClose, exportCourseList }) => {
  const scrollableAreaRef = useRef(null);
  const [exportType, setExportType] = useState();

  const onConfirm = () => {
    if (exportType === 'pdf') {
      window.open(
        `${window.location.origin}${routes.downloadCatalog.path}`,
        '_blank'
      );
    } else if (exportType === 'csv') {
      const activeTab = storage.read('activeTab')?.value;
      const storageFilters =
        storage.read(
          activeTab === 'modules' ? 'moduleFilters' : 'courseFilters'
        )?.value || {};
      exportCourseList({ ...storageFilters, items_per_page: 100 });
    }
  };

  return (
    <Modal
      title="Seleziona il formato per l'export"
      modalId={ModalSelectExportId}
      scrollableAreaRef={scrollableAreaRef}
      compact
    >
      <ScrollableArea ref={scrollableAreaRef}>
        <fieldset>
          <Text type="b2" mb={32} tag="legend">
            Seleziona il formato per eseguire l'export
          </Text>
          <RadioWrapper>
            <RadioButton
              label=".csv"
              name="export-type"
              checked={exportType === 'csv'}
              onChange={() => setExportType('csv')}
            />
            <RadioButton
              label=".pdf"
              name="export-type"
              checked={exportType === 'pdf'}
              onChange={() => setExportType('pdf')}
            />
          </RadioWrapper>
        </fieldset>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="conferma"
          disabled={!exportType}
          fullsize={mediaIsPhone}
          onClick={() => {
            onConfirm();
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalSelectExport.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state

  // dispatch
  modalClose: PropTypes.func.isRequired,
  exportCourseList: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      return {};
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      exportCourseList: (filters) =>
        dispatch({
          type: GLOBAL_COURSE_LIST_EXPORT._REQUEST,
          filters,
        }),
    })
  ),
  withMediaQueries
)(ModalSelectExport);
